import { WwWorkType } from '@/configs/enums/commons';

export default [
  {
    path: '/announce/detail/:id',
    name: 'announce-detail',
    component: () =>
      import('@/views/admin/main/components/announce/Preview.vue'),
    meta: { layout: 'front' },
  },

  {
    path: '/announce/review/:id',
    name: 'announce-review',
    component: () =>
      import('@/views/admin/main/components/announce/Review.vue'),
    meta: {
      layout: 'front',
      redirectType: WwWorkType.资讯公告, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
  },
];
